import React, { useState } from 'react';
import '../../css/Admin.css';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

const AdminStatsSignupChart = ({ globalStats, title = "Évolution des utilisateurs" }) => {
  const [isOpen, setIsOpen] = useState(true);

  if (!globalStats || globalStats.length === 0) return <p>Aucune donnée disponible.</p>;

  // Calcul cumulatif
  let cumulative = 0;
  const chartData = globalStats.map(g => {
    cumulative += g.nbSignups || 0;
    return {
      week: new Date(g.weekStart).toLocaleDateString(),
      totalUsers: cumulative,
    };
  });

  const totalUsers = cumulative;
  const delta = globalStats.length > 1 
    ? chartData[chartData.length - 1].totalUsers - chartData[chartData.length - 2].totalUsers
    : 0;
  const deltaText = delta > 0 ? `+${delta}` : '';

  return (
    <div className="admin-signup-chart-container">
      {/* Titre du panel avec toggle */}
      <h2 
        className="signup-chart-title cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        {title} {isOpen ? '▼' : '▲'}
      </h2>

      {isOpen && (
        <div className="signup-chart-wrapper">
          {/* Graphique 80% */}
          <div className="signup-chart">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={chartData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                <defs>
                  <linearGradient id="colorSignups" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#4ade80" stopOpacity={0.8}/>
                    <stop offset="95%" stopColor="#4ade80" stopOpacity={0}/>
                  </linearGradient>
                </defs>
                <XAxis dataKey="week" tick={{ fontSize: 12 }} />
                <YAxis />
                <Tooltip />
                <Area type="monotone" dataKey="totalUsers" stroke="#22c55e" fill="url(#colorSignups)" />
              </AreaChart>
            </ResponsiveContainer>
          </div>

          {/* Cercle 20% */}
          <div className="total-users-circle">
            <div className="total-users-circle-inner">
              <span>{totalUsers}</span>
              {deltaText && <span className="delta">{deltaText} cette semaine</span>}
            </div>
            <div className="total-users-label">Utilisateurs totaux</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminStatsSignupChart;
